import React from 'react';

import { ProfileMenu } from '@/features/accountSettings';
import { LogoutButton } from '@/features/auth';
import { NotificationsMenu } from '@/features/notifications';
import { PageTitle } from '@/features/pageTitle';
import { Stack } from '@/shared/ui';

import {
  StyledAppBar,
  StyledHeaderContainer,
  StyledMainContentContainer,
} from './styles';

export const Header = () => {
  return (
    <StyledAppBar position="static">
      <StyledHeaderContainer>
        <StyledMainContentContainer>
          <PageTitle />

          <Stack direction="row" spacing={2} alignItems="center">
            {/* <BalanceBox> */}
            {/*  <IconButton */}
            {/*    size="medium" */}
            {/*    aria-label={t('common:header.balance.title')} */}
            {/*  > */}
            {/*    <SvgIcon name="wallet" /> */}
            {/*  </IconButton> */}
            {/* </BalanceBox> */}

            <NotificationsMenu />
            <ProfileMenu actionsSlot={<LogoutButton />} />
          </Stack>
        </StyledMainContentContainer>
      </StyledHeaderContainer>
    </StyledAppBar>
  );
};
